import { render, staticRenderFns } from "./LandingCreatorsSuccessStories.vue?vue&type=template&id=229a055b&scoped=true&"
import script from "./LandingCreatorsSuccessStories.vue?vue&type=script&lang=ts&"
export * from "./LandingCreatorsSuccessStories.vue?vue&type=script&lang=ts&"
import style0 from "./LandingCreatorsSuccessStories.vue?vue&type=style&index=0&id=229a055b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a055b",
  null
  
)

export default component.exports